import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

import ServicesGeneral from "@/components/pages/services/ServicesGeneral"

export default {
    path: '/services',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
    component: ServicesGeneral,
    children: [
        { path: '', redirect: '/services/services' },
        {
            path: 'services', name: "ServicesServices",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
            component: () => import('../components/pages/services/Services.vue')
        },
        {
            path: 'categories', name: "ServicesCategories",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
            component: () => import('../components/pages/services/Categories.vue')
        },
        {
            path: 'archive', name: "ServicesArchive",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
            component: () => import('../components/pages/services/Archive.vue')
        },
        {
            path: 'prices', name: "ServicesPrices",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
            component: () => import('../components/pages/services/Prices.vue')
        },
        {
            path: 'complex_services', name: "ServicesComplexServices",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['clinic_services'] },
            component: () => import('../components/pages/services/ComplexServices.vue')
        },
    ]
}
